var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div data-ng-controller=\"HomeController as that\" class=\"home\">\n<a href=\"/idp/login.html\" class=\"btn btn-primary btn-lg\">Login</a>\n<h2>Components:</h2>\n<div data-ng-repeat=\"component in that.components\">\n<h3>\n{{ component.name }}<span data-ng-if=\"!component.success\">\n<span class=\"label label-danger\" data-ng-if=\"!component.success\">Failed</span></span>:\n</h3>\n<pre class=\"productInfo\">{{ component.data | json }}</pre>\n</div>\n</div>\n";
var id1="views/home.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ../partials/views/home.html
// module id = 147
// module chunks = 0